module.exports = __webpack_public_path__ + "img/fun02.bdc50ae0.png";